export default function RejectIcon() {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="27" height="27" rx="5.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="27"
          height="27"
          rx="5.5"
          stroke="#D7DFE9"
        />
        <path
          d="M19.0625 8.9375L8.9375 19.0625M19.0625 19.0625L8.9375 8.9375"
          stroke="#8897AE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
